module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-mobile-03-0a4b9665d6cf69807644a491671ff3b8.jpg";